import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { ModalConfig } from '@core/models/modal-config.model';
import { AppState } from '@core/store';
import { selectMultiplePurchaseLimitRuleModal } from '@core/store/cart';
import { MultiplePurchaseLimitRuleModal } from '@core/store/cart/cart-state-models';
import { fetchCart, resetMultiplePurchaseLimitRuleModal } from '@core/store/cart/cart.actions';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-purchase-limit-multiple-line-modal',
  templateUrl: './purchase-limit-multiple-line-modal.component.html',
  styleUrls: ['./purchase-limit-multiple-line-modal.component.scss'],
})
export class PurchaseLimitMultipleLineModalComponent implements OnDestroy, AfterViewInit {
  @Input() isPaymentStep: boolean = false;
  @Input() isCartEmpty: boolean = false;
  @Output() okClicked: EventEmitter<void> = new EventEmitter<void>();

  data$: Observable<MultiplePurchaseLimitRuleModal>;

  modalConfig: ModalConfig = {
    hideHeader: true,
    hideCloseButton: true,
    hideDismissButton: true,
    ngbModalOptions: {
      size: 'md',
      windowClass: 'purchase-limit-multiple-line-modal-window',
    },
    title: $localize`Some items require your attention`,
    onDismiss: this.close.bind(this),
  };
  okButtonText: string = $localize`Continue`;

  private subscriptions = new Subscription();
  @ViewChild('modal') private modal: ModalComponent;

  constructor(
    private store$: Store<AppState>,
    private router: Router,
  ) {
    this.data$ = this.store$.select(selectMultiplePurchaseLimitRuleModal);
  }

  ngAfterViewInit(): void {
    this.subscriptions.add(
      this.data$
        .pipe(
          filter(
            (data) =>
              data.shouldOpenModal &&
              (data.items?.backorderItems?.length > 0 || data.items?.nonBackorderItems?.length > 0),
          ),
        )
        .subscribe(() => {
          this.modal.open();
        }),
    );

    this.okButtonText = this.isPaymentStep ? $localize`Submit order` : $localize`Continue`;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  close(): void {
    this.store$.dispatch(fetchCart());
    this.store$.dispatch(resetMultiplePurchaseLimitRuleModal());
    this.modal.close();
  }

  ok(): void {
    if (this.isCartEmpty) {
      this.router.navigate(['/']);
    } else {
      this.okClicked.emit();
    }
    this.close();
  }
}
